import "coloris/dist/coloris.js";
import "coloris/dist/coloris.css";

type ColorisOptions = {
  el?: string;
  wrap?: boolean;
  alpha?: boolean;
  format?: "hex";
  themeMode?: "light";
  closeButton?: boolean;
  closeLabel?: string;
  swatches?: string[];
  a11y?: Record<string, string>;
};

declare global {
  interface Window {
    Coloris: {
      (options: ColorisOptions): void;
      close: () => void;
      updatePosition: () => void;
    };
  }
}

// Keep React in charge of input markup; Coloris renders its dialog in the body.
window.Coloris({ el: ".builder-color-input", wrap: false, alpha: false,
  format: "hex", themeMode: "light", closeButton: true });
